import { ContractingProcessAnswerProps } from "features/contracting/models/ContractingProcessAnswerProps";
import React from "react";

interface Props extends ContractingProcessAnswerProps {}

const NoTerminationMyselfSubForm = ({ }: Props) => {
  // render
  return (
    <></>
  );
};

export default NoTerminationMyselfSubForm;
